import { jsx as _jsx } from "react/jsx-runtime";
import { textStyling } from './styling';
import { cn } from '../../utils';
export function Text({ children, weight, className, type, as: Component = 'p' }) {
    // If no type is provided, default to the same as the component type
    if (!type) {
        type = Component;
    }
    return (_jsx(Component, { className: cn(textStyling({ type, weight }), className), children: children }));
}
